export default __webpack_public_path__ + "static/media/gesture.d9e2bd85.svg";